const DistanceCostScheme = {
  distanceTable: {
    width: "100%",
    borderCollapse: "collapse",
    "& td": {
      border: "1px solid #ddd",
      padding: "0px 15px",
    },
    "& th": {
      border: "1px solid #ddd",
      padding: "0px 15px",
    },
  },
};

export default DistanceCostScheme;
